import { render, staticRenderFns } from "./turnover-list.vue?vue&type=template&id=b26009f0&scoped=true"
import script from "./turnover-list.vue?vue&type=script&lang=ts"
export * from "./turnover-list.vue?vue&type=script&lang=ts"
import style0 from "./turnover-list.vue?vue&type=style&index=0&id=b26009f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26009f0",
  null
  
)

export default component.exports